<ng-content></ng-content>
<div class="product-list  grid grid-gap-big">
  <div *ngFor='let product of productsData' [routerLink]="['product', product.sku]" class="xs-6 m-4 l-3 product-card">

    <div class="product-image">
      <img loading="lazy" src="{{ product.images.freestanding_1  | image}}">
      <button (click)="addTocart($event, product)">
        <svg xmlns="http://www.w3.org/2000/svg" width="27.288" height="30.499" viewBox="0 0 27.288 30.499">
          <g id="Gruppe_326" data-name="Gruppe 326" transform="translate(0.329 0.322)">
            <g id="Gruppe_327" data-name="Gruppe 327">
              <path id="Pfad_155" data-name="Pfad 155"
                    d="M21.87,39.457H5.4A4.9,4.9,0,0,1,.553,33.84l2.53-17.192A1.69,1.69,0,0,1,4.755,15.2H22.519a1.69,1.69,0,0,1,1.672,1.444l2.53,17.192A4.9,4.9,0,0,1,21.87,39.457Z"
                    transform="translate(-0.322 -9.779)" fill="none" stroke="#333" stroke-miterlimit="10"
                    stroke-width="1"/>
              <path id="Pfad_156" data-name="Pfad 156" d="M18.364,5.844a5.344,5.344,0,1,1,10.689,0"
                    transform="translate(-11.811 -0.322)" fill="none" stroke="#333" stroke-miterlimit="10"
                    stroke-width="1"/>
              <path id="Pfad_157" data-name="Pfad 157" d="M23.157,9.993V5.844a5.344,5.344,0,1,1,10.689,0V9.993"
                    transform="translate(-14.894 -0.322)" fill="none" stroke="#333" stroke-miterlimit="10"
                    stroke-width="1"/>
              <circle id="Ellipse_49" data-name="Ellipse 49" cx="0.45" cy="0.45" r="0.45"
                      transform="translate(7.813 9.221)" fill="none" stroke="#333" stroke-miterlimit="10"
                      stroke-width="1"/>
              <circle id="Ellipse_50" data-name="Ellipse 50" cx="0.45" cy="0.45" r="0.45"
                      transform="translate(18.502 9.221)" fill="none" stroke="#333" stroke-miterlimit="10"
                      stroke-width="1"/>
              <line id="Linie_50" data-name="Linie 50" x2="12.174" transform="translate(7.228 18.657)"
                    fill="none"
                    stroke="#333" stroke-miterlimit="10" stroke-width="1"/>
              <line id="Linie_51" data-name="Linie 51" y2="12.174" transform="translate(13.315 12.57)"
                    fill="none"
                    stroke="#333" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </g>
        </svg>
      </button>
    </div>
    <div class="product-info-box">
      <h2 [innerHTML]="product.texts.caption | i18next"></h2>
      <div *ngIf="priceActive" class="price">
            <span class="line">

            </span>
        <ng-container *ngIf="product.price">
          {{product.price | currency: collectionsService.currencyCode:currencySymbol:'1.2-2': 'de'}}
        </ng-container>
      </div>
      <small class="ean text-right">{{ product.sku | skuFormatter }}</small>
    </div>
  </div>
</div>


